// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"AppUpdatePage_mainContainer__2t4qV","actionButton":"AppUpdatePage_actionButton__21M-9","titleCentered":"AppUpdatePage_titleCentered__3v0Ig"};